import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { ItemOverviewScreen } from '@configuratorware/configurator-frontendgui/App/Screens/ItemOverview/Screen';
import ItemOverview from '@configuratorware/configurator-frontendgui/App/Screens/ItemOverview/Components/ItemOverview';
import CustomThemeProvider from '../ThemeProvider';

// Our theme's CssBaseline pins body/#root for the fixed-height configurator (no body
// scroll). The product overview is a normal scrolling page, so give it its own
// full-height scroll container inside #root rather than letting content clip.
const styles = () => ({
  root: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflowY: 'auto',
  },
});

const CustomItemOverviewScreen = withStyles(styles)(({ classes, ...props }) => (
  <ItemOverviewScreen
    {...props}
    ThemeProvider={CustomThemeProvider}
    renderItemOverview={(itemOverviewProps) => (
      <div className={classes.root}>
        <ItemOverview {...itemOverviewProps} />
      </div>
    )}
  />
));

export default CustomItemOverviewScreen;
